import { useMatches } from "react-router";

import type { RouteHandle } from "shell/platform/types/types";

export const useHideChrome = (): boolean => {
  const matches = useMatches();

  return (
    [...matches]
      .reverse()
      .map(m => m.handle as RouteHandle | undefined)
      .find(handle => handle?.hideChrome !== undefined)?.hideChrome ?? false
  );
};
